export const isNonNullString = (value: unknown): value is string => {
  return typeof value === 'string' && value.trim() !== ''
}

export const isPositiveNumber = (value: unknown): value is number => {
  return typeof value === 'number' && value >= 0
}

export const cleanDuplicateSuffix = (name: string) => {
  return name.replace(/\s\(\d+\)$/, '')
}

export const generateSlug = (text: string): string => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remove special characters
    .replace(/[\s_-]+/g, '-') // Replace spaces and underscores with hyphens
    .replace(/^-+|-+$/g, '') // Remove leading/trailing hyphens
}
